<template>
	<div>
		<div v-if="showTitle" class="col-md-12 px-0 mb-1 d-flex align-items-center justify-content-center">
			<div>
				<h5>{{ tabLabel }}</h5>
			</div>
			<div class="ml-auto">

				<el-checkbox border size="small" class="me-2" v-model="showchart" v-show="tabName == 'atg' || tabName == 'spbuupdate' || tabName == 'storeupdate'">
					Show Chart
				</el-checkbox>

				<el-popover trigger="click" size="small" ref="dropdown" v-model="dropdownVisible" popper-class="dropdown-filter">
					<el-button slot="reference" type="primary" plain size="small">
						<i class="fa fa-filter"></i> &nbsp; Filter
					</el-button>
					<div>
						<div class="ps-3 pe-3 pt-1 pb-1">
							<h5><i class="fa fa-filter"></i> &nbsp; Filter {{ tabLabel }}</h5>
						</div>
						<el-divider class="m-0"></el-divider>
						<div class="dropdown-filter-form">
							<el-form label-position="top" label-width="100px">
								<div class="row">
									<div class="col-md-6" v-if="tabName != 'login_history' && tabName != 'storeupdate'">
										<el-form-item label="Station:">
											<el-select v-model="stationid" clearable filterable placeholder="Select" size="medium" style="width:100%;">
												<el-option v-for="item3 in spbu.list" :key="item3.StationId" :label="item3.StationName" :value="item3.StationId">
												</el-option>
											</el-select>
										</el-form-item>
									</div>

									<div class="col-md-6" v-if="tabName == 'storeupdate'">
										<el-form-item label="Branch:">
											<el-select v-model="branch" clearable filterable placeholder="Select" size="medium" style="width:100%;">
												<el-option v-for="item3 in store.list" :key="item3.BranchId" :label="item3.BranchName" :value="item3.BranchId">
												</el-option>
											</el-select>
										</el-form-item>
									</div>

									<div class="col-md-6" v-if="false">
										<el-form-item label="Station:">
											<el-select v-model="stationid" clearable filterable placeholder="Select" size="medium" style="width:100%;">
												<el-option v-for="item3 in spbu.list" :key="item3.StationId" :label="item3.StationName" :value="item3.BOSStationId">
												</el-option>
											</el-select>
										</el-form-item>
									</div>

									<div class="col-md-6" v-if="tabName == 'last_pump_transaction'">
										<el-form-item label="Status:">
											<el-radio-group v-model="pumpstatus" size="small">
												<el-radio-button :label="item2.value" v-for="(item2, index2) in options.pumpstatus" :key="item2.value+'_'+index2" style="margin-left:0px;">{{item2.name}}</el-radio-button>
											</el-radio-group>
										</el-form-item>
									</div>

									<div class="col-md-6" v-if="tabName=='atg'">
										<el-form-item label="Detail:">
											<el-radio-group v-model="atgdetail" size="small">
												<el-radio-button :label="item2.value" v-for="(item2, index2) in options.atgdetail" :key="item2.value+'_'+index2" style="margin-left:0px;">{{item2.name}}</el-radio-button>
											</el-radio-group>
										</el-form-item>
									</div>

									<div class="col-md-12" v-show="tabName =='spbuupdate'">
										<el-form-item label="Type">
											<el-radio-group v-model="stationtype" size="small" name="type">
												<el-radio-button :label="item5.value" v-for="(item5, index5) in options.types" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
											</el-radio-group>
										</el-form-item>
									</div>

									<div class="col-md-6" v-if="tabName != 'last_pump_transaction' && tabName != 'login_history' && tabName != 'station_database_size'">
										<el-form-item label="Area:">
											<el-radio-group v-model="area" size="small">
												<el-radio-button :label="item2.value" v-for="(item2, index2) in options.area" :key="item2.value+'_'+index2" style="margin-left:0px;">{{item2.name}}</el-radio-button>
											</el-radio-group>
										</el-form-item>
									</div>

									<div class="col-md-6" v-if="tabName == 'atg' || tabName == 'spbuupdate'">
										<el-form-item label="Region:">
											<el-radio-group v-model="region" size="small">
												<el-radio-button :label="item2.value" v-for="(item2, index2) in options.region" :key="item2.value+'_'+index2" style="margin-left:0px;">{{item2.name}}</el-radio-button>
											</el-radio-group>
										</el-form-item>
									</div>

									<div class="col-md-6" v-if="tabName=='atg'">
										<el-form-item label="ATG Status:">
											<el-radio-group v-model="status" size="small">
												<el-radio-button :label="item2.value" v-for="(item2, index2) in options.status" :key="item2.value+'_'+index2" style="margin-left:0px;">{{item2.name}}</el-radio-button>
											</el-radio-group>
										</el-form-item>
									</div>

									<div class="col-md-6" v-if="tabName=='spbuupdate' || tabName=='storeupdate'">
										<el-form-item label="Update:">
											<el-radio-group v-model="update" size="small">
												<el-radio-button :label="item2.value" v-for="(item2, index2) in options.update" :key="item2.value+'_'+index2" style="margin-left:0px;">{{item2.name}}</el-radio-button>
											</el-radio-group>
										</el-form-item>
									</div>

									<div class="col-md-6" v-if="tabName == 'login_history' || tabName == 'station_database_size'">
										<el-form-item label="Date Range:">
											<div class="block">
												<el-date-picker
												v-model="dateRange"
												type="daterange"
												align="right"
												size="small"
												unlink-panels
												range-separator="-"
												start-placeholder="Start date"
												end-placeholder="End date"
												format="yyyy-MM-dd"
												value-format="yyyy-MM-dd"
												:picker-options="pickerOptions">
												</el-date-picker>
											</div>
										</el-form-item>
									</div>

									<div class="col-md-6" v-if="tabName == 'login_history'">
										<el-form-item label="Username">
											<el-input placeholder="Username ..." v-model="username" size="medium" maxlength="100"></el-input>
										</el-form-item>
									</div>

								</div>

							</el-form>
						</div>
						<el-divider class="m-0"></el-divider>
						<div class="py-2 px-4">
							<div class="row">
								<div class="col-md-12 d-flex align-items-center">
									<div class="ml-auto">
										<el-button type="danger" size="medium" @click="closeDropdownForm" style="min-width:100px;"><i class="fa fa-close"></i> &nbsp; Close</el-button>
										<el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="min-width:100px;"><i class="fa fa-check"></i> &nbsp; Apply Filter</el-button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</el-popover>

				<el-button class="ms-2" type="success" plain size="small" @click="exportExcel()" v-if="reportdata?.data?.length">
					<i class="fa fa-file-excel"></i> &nbsp; Export
				</el-button>
				<vue-excel-xlsx
					v-show="false"
					ref="excelExport"
					:data="dataXLSX(reportdata)"
					:columns="columnXLSX(reportdata)"
					:file-name="'Maintenance Report ' + tabLabel"
					:file-type="'xlsx'"
					:sheet-name="'sheet1'"
					>
					<i class="far fa-file-excel"></i>
				</vue-excel-xlsx>

			</div>
		</div>

		<div class="row" v-if="false">
			<div class="mb-3">
				<el-collapse>
					<el-collapse-item>
						<template slot="title">
							<span style="color:#606266;font-size:14px;"><i class="header-icon el-icon-search"></i>&nbsp;&nbsp;&nbsp;Filter</span>
						</template>
						<el-form label-position="top" label-width="100px">
							<div class="row">
								<div class="col-md-6" v-if="tabName != 'last_pump_transaction' && tabName != 'login_history' && tabName != 'storeupdate'">
									<el-form-item label="Station:">
										<el-select v-model="stationid" clearable filterable placeholder="Select" size="medium" style="width:100%;">
											<el-option v-for="item3 in spbu.list" :key="item3.StationId" :label="item3.StationName" :value="item3.StationId">
											</el-option>
										</el-select>
									</el-form-item>
								</div>

								<div class="col-md-6" v-if="tabName == 'storeupdate'">
									<el-form-item label="Branch:">
										<el-select v-model="branch" clearable filterable placeholder="Select" size="medium" style="width:100%;">
											<el-option v-for="item3 in store.list" :key="item3.BranchId" :label="item3.BranchName" :value="item3.BranchId">
											</el-option>
										</el-select>
									</el-form-item>
								</div>

								<div class="col-md-6" v-if="tabName == 'last_pump_transaction'">
									<el-form-item label="Station:">
										<el-select v-model="stationid" clearable filterable placeholder="Select" size="medium" style="width:100%;">
											<el-option v-for="item3 in spbu.list" :key="item3.StationId" :label="item3.StationName" :value="item3.BOSStationId">
											</el-option>
										</el-select>
									</el-form-item>
								</div>

								<div class="col-md-6" v-if="tabName == 'last_pump_transaction'">
									<el-form-item label="Status:">
										<el-radio-group v-model="pumpstatus" size="small">
											<el-radio-button :label="item2.value" v-for="(item2, index2) in options.pumpstatus" :key="item2.value+'_'+index2" style="margin-left:0px;">{{item2.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>

								<div class="col-md-6" v-if="tabName=='atg'">
									<el-form-item label="Detail:">
										<el-radio-group v-model="atgdetail" size="small">
											<el-radio-button :label="item2.value" v-for="(item2, index2) in options.atgdetail" :key="item2.value+'_'+index2" style="margin-left:0px;">{{item2.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>

							</div>

							<div class="row">
								<div class="col-md-12" v-show="tabName =='spbuupdate'">
									<el-form-item label="Type">
										<el-radio-group v-model="stationtype" size="small" name="type">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.types" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>
							</div>

							<div class="row">
								<div class="col-md-6" v-if="tabName != 'last_pump_transaction' && tabName != 'login_history'">
									<el-form-item label="Area:">
										<el-radio-group v-model="area" size="small">
											<el-radio-button :label="item2.value" v-for="(item2, index2) in options.area" :key="item2.value+'_'+index2" style="margin-left:0px;">{{item2.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>

								<div class="col-md-6" v-if="tabName=='atg'">
									<el-form-item label="ATG Status:">
										<el-radio-group v-model="status" size="small">
											<el-radio-button :label="item2.value" v-for="(item2, index2) in options.status" :key="item2.value+'_'+index2" style="margin-left:0px;">{{item2.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>

								<div class="col-md-6" v-if="tabName=='spbuupdate' || tabName=='storeupdate'">
									<el-form-item label="Update:">
										<el-radio-group v-model="update" size="small">
											<el-radio-button :label="item2.value" v-for="(item2, index2) in options.update" :key="item2.value+'_'+index2" style="margin-left:0px;">{{item2.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>

							</div>

							<div class="row" v-if="tabName == 'login_history'">
								<div class="col-md-6">
									<el-form-item label="Date Range:">
										<div class="block">
											<el-date-picker
											v-model="dateRange"
											type="daterange"
											align="right"
											size="small"
											unlink-panels
											range-separator="-"
											start-placeholder="Start date"
											end-placeholder="End date"
											format="yyyy-MM-dd"
											value-format="yyyy-MM-dd"
											:picker-options="pickerOptions">
											</el-date-picker>
										</div>
									</el-form-item>
								</div>

								<div class="col-md-6">
									<el-form-item label="Username">
										<el-input placeholder="Username ..." v-model="username" size="medium" maxlength="100"></el-input>
									</el-form-item>
								</div>
							</div>

							<div class="row">
								<div class="col-md-6">
									<el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply Filter</el-button>
								</div>
							</div>
						</el-form>
					</el-collapse-item>
				</el-collapse>
			</div>

		</div>

		<div class="row">
			<div class="col-md-3 mb-3" v-if="false">
				<el-checkbox v-model="showchart">Show Chart</el-checkbox>
			</div>
			<div class="col-md-8 mb-3" v-if="showchart">
				<el-radio-group v-model="charttype">
					<el-radio label="piechart" size="small">Pie Chart</el-radio>
					<el-radio label="barchart" size="small">Bar Chart</el-radio>
					<el-radio label="linechart" size="small">Line Chart</el-radio>
				</el-radio-group>
			</div>

		</div>

		<div class="mb-0" >
			<PieChart v-loading.body="loading.table" :data="this.pieChartData()" :url="''" :height="380" style="width:280px;" v-if="showchart && charttype=='piechart' && tabName=='atg'" />
			<PieChart v-loading.body="loading.table" :data="this.pieChartDataUpdate()" :url="''" :height="380" style="width:280px;" v-if="showchart && charttype=='piechart' && tabName=='spbuupdate'" />
			<PieChart v-loading.body="loading.table" :data="this.pieChartDataStoreUpdate()" :url="''" :height="380" style="width:280px;" v-if="showchart && charttype=='piechart' && tabName=='storeupdate'" />

			<BarChart v-loading.body="loading.table" :data="chartdata" :width="500" :height="380" v-if="showchart && charttype=='barchart'" />
			<LineChart v-loading.body="loading.table" :data="chartdata" :width="500" :height="192" v-if="showchart && charttype=='linechart'" style="margin-top:20px;"/>
		</div>

		<div class="mt-0">
			<ReportResultTable :reportname="'MaintenanceReport'" :reportdata="reportdata" :loading="loading.table" :reporturl="urlRequestParams" :issuccess="loading.isSuccess" style="width:100%;"/>
		</div>

	</div>
</template>

<script>

import Maintenance from '@/components/page/Maintenance.js'
import ReportParamSelect from '@/views/pages/ReportParamSelect.vue'
import ReportResultTable from '@/views/pages/ReportResultTable3.vue'
import { Rainbow, Rainbow2, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader.vue'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'
import PieChart from '@/components/chart/Pie.js'


export default
{
	extends: Maintenance,
	props: ['tabIndex','tabName', 'tabLabel', 'showTitle'],
	components: {
		//ReportParamSelect,
		ReportResultTable,
		LineChart,
		BarChart,
		PieChart,
		//Loader,
	},

	data(){
		return {
			options: {
				detail1:[
					{ value: "", name: "ALL" },
					{ value: "station", name: "BY STATION" },
				],
				detail2:[
					{ value: "", name: "ALL" },
					{ value: "group", name: "BY GROUP", field: "ProductGroup" },
					{ value: "product", name: "BY PRODUCT", field: "ProductName" },
				],
				area:[
					{ value: "", name: "ALL" },
					//{ value: "area", name: "BY AREA", field: "SalesArea" },
					{ value: "1", name: "1" },
					{ value: "2", name: "2" },
					{ value: "3", name: "3" },
					{ value: "4", name: "4" },
					{ value: "5", name: "5" },
				],
				region:[
					{ value: "", name: "ALL" },
					//{ value: "region", name: "BY REGION", field: "RegionPertareId" },
					{ value: "1", name: "1" },
					{ value: "2", name: "2" },
					{ value: "3", name: "3" },
					{ value: "4", name: "4" },
					{ value: "5", name: "5" },
					{ value: "6", name: "6" },
					{ value: "7", name: "7" },
				],
				update:[
					{ value: "", name: "ALL" },
					{ value: "1", name: "UPDATE" },
					{ value: "0", name: "NOT UPDATE" },
				],
				status:[
					{ value: "", name: "ALL" },
					{ value: "ONLINE", name: "ONLINE" },
					{ value: "OFFLINE", name: "OFFLINE" },
				],
				atgdetail: [
					{ value: "detail", name: "DETAIL" },
					{ value: "rekap", name: "REKAP" },
				],
				pumpstatus: [
					{ value: "", name: "ALL" },
					{ value: "1", name: "ACTIVE" },
					{ value: "0", name: "NOT ACTIVE" },
				],
				types:[
					{ value: '', name: 'ALL' },
					//{ value: 'by_station_type', name: 'BY STATION TYPE' },
					{ value: 'SPBU', name: 'SPBU' },
					{ value: 'SPBG', name: 'SPBG' },
					{ value: 'PERTASHOP', name: 'PERTASHOP' },
					{ value: 'SPBU-T', name: 'SPBU-T' },
					{ value: 'SHELTER', name: 'SHELTER' },
					{ value: 'MODULAR', name: 'MODULAR' },
					{ value: 'SATGAS', name: 'SATGAS' },
				],
			},

			loading: {
				table: false,
				chart: false,
				isSuccess: false,
			},

			dateRange: [this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().sekarang, this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().sekarang],

			pumpstatus: '',
			charttype: 'linechart', //barchart //linechart
			showchart: false,
			stationList: [],
			atgdetail: 'rekap',
			username: '',
			//tabIndex: this.$route.query.tab ? this.$route.query.tab : 0,
			reportdata: [],
			chartdata: [],
			showchartupdate: false,
			showchartstoreupdate: false,
			stacked: true,
			stationid: this.$route.query.station ? this.$route.query.station : '',
			branch: this.$route.query.branch ? this.$route.query.branch : '',
			area: this.$route.query.area ? this.$route.query.area : '',
			region: this.$route.query.region ? this.$route.query.region : '',
			status: this.$route.query.status ? this.$route.query.status : '',
            update: this.$route.query.update ? this.$route.query.update : '0',
			stationtype: this.$route.query.stationtype ? this.$route.query.stationtype : 'SATGAS',
			urlRequestParams: '',

			pickerOptions: {
				shortcuts: [{
					text: 'Last week',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last month',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last 3 months',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
					picker.$emit('pick', [start, end]);
					}
				}]
			},

			is2024OrBelow: false,
			is2025OrAbove: true,
			dropdownVisible: false,

		}
	},
	watch:
	{
		//area() { this.resumePilihan() },
		//status(){ this.resumePilihan() },

	},
    mounted()
    {
        this.$emit('childrenRoute');
		this.loadStationList()
		if(this.tabName == 'storeupdate')
			this.loadStoreList3()

		//this.resumePilihan()
		this.loadRecapMonitor();
    },
    methods:{
		floatingSearchForm(){
			document.querySelector('.search.form').classList.toggle('floating')
		},
		searchFilterButtonClick(){
			document.querySelector('li.filter').classList.toggle('down')
			var select=document.querySelectorAll('.search.form')
			Array.from(select).map((e)=>{e.classList.toggle('minimize')})
		},

		async resumePilihan(){
			this.urlRequestParams=Config().apiURL
			if (this.tabIndex == 0) this.urlRequestParams+='/maintenance/tankmonitor?'
			else if (this.tabIndex == 1) this.urlRequestParams+='/maintenance/spbuupdate?'
			else if (this.tabIndex == 2) this.urlRequestParams+='/maintenance/storeupdate?'
			else if (this.tabIndex == 5) this.urlRequestParams+='/fuel2/last-pump-transaction?'
			else if (this.tabIndex == 6) this.urlRequestParams+='/maintenance/login-history?'
			else if (this.tabIndex == 10) this.urlRequestParams+='/v1/maintenance/stationdatabasesize?'
			//else this.urlRequestParams+='/maintenance/tankmonitor?'

			this.urlRequestParams+='&station='+this.stationid
			this.urlRequestParams+='&branch='+this.branch
			this.urlRequestParams+='&area='+this.area
			this.urlRequestParams+='&region='+this.region
			this.urlRequestParams+='&status='+this.status
            this.urlRequestParams+='&update='+this.update
			this.urlRequestParams+='&atgdetail='+this.atgdetail
			this.urlRequestParams+='&pumpstatus='+this.pumpstatus

			this.urlRequestParams+='&username='+this.username
			this.urlRequestParams+='&date-range-start='+ (this.dateRange ? this.dateRange[0] : 'undefined')
			this.urlRequestParams+='&date-range-end='+ (this.dateRange ? this.dateRange[1] : 'undefined')
			this.urlRequestParams+='&type='+this.stationtype

			this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					this.reportdata = response.data;
					this.loading.isSuccess = true;
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})
        },

		refreshChart() {
			let opt = this.getoption(this.detail2, this.options.detail2)
			let a = opt && opt.field ? opt.field : ""

			opt = this.getoption(this.area, this.options.area)
			a = opt && opt.field ? opt.field : a

			let b = "Period"
			let c = (a == "ProductName") ? FuelColor : Rainbow

			this.chartdata = this.processBarChart(this.reportdata.data, a, "", "SalesVolume", false, b, "", 1000, 2, c, false, false, false, this.stacked);
		},

		pieChartData()
        {
			var warna=[]
			warna["OFFLINE"]='rgba(255,0,0,1)'
			warna["ONLINE"]='rgba(0,0,255,1)'

			return this.processPieChart(
				[
					{
						transtype: "ONLINE",
						amount: this.totalAtgOnline,
					},
					{
						transtype: "OFFLINE",
						amount: this.totalAtgOffline,
					}
				],
				"amount", "transtype", 0, 2, warna
			);

			/*
			return  {
				labels: ['Pie 1', 'Pie 2', 'Pie 3', 'Pie 4', 'Pie 5'],
				datasets: [
					{
						backgroundColor: [ '#1E9600', '#99C802', '#FFF200', '#F89403',	'#FF0000' ],
						data: [1, 2, 3, 4, 5],
					},
				],
			} */

        },

		pieChartDataUpdate()
        {
			var warna=[]
			warna["NOT UPDATE"]='rgba(255,0,0,1)'
			warna["UPDATED"]='rgba(0,0,255,1)'

			return this.processPieChart(
				[
					{
						transtype: "UPDATED",
						amount: this.totalSpbuUpdate,
					},
					{
						transtype: "NOT UPDATE",
						amount: this.totalSpbuNotUpdate,
					}
				],
				"amount", "transtype", 0, 2, warna
			);
        },

		pieChartDataStoreUpdate()
        {
			var warna=[]
			warna["STORE NOT UPDATE"]='rgba(255,0,0,1)'
			warna["STORE UPDATED"]='rgba(0,0,255,1)'

			return this.processPieChart(
				[
					{
						transtype: "STORE UPDATED",
						amount: this.totalStoreUpdate,
					},
					{
						transtype: "STORE NOT UPDATE",
						amount: this.totalStoreNotUpdate,
					}
				],
				"amount", "transtype", 0, 2, warna
			);
        },

		applyFilter() {
			this.dropdownVisible = false;
			this.resumePilihan()
			//this.getMetricTitleName()
			//this.getBaselineComparison()
			//this.getBaselineChartSelfServiceSales()
        },

		exportExcel() {
			this.$refs["excelExport"].exportExcel();
			//console.log('export excel');
		},

		closeDropdownForm() {
			this.dropdownVisible = false;
		},

    },
    computed: {
        totalAtgOnline() {
			return this.unit.atgonline.reduce((acc, item) => acc + item.Cnt, 0);
            //return this.reportdata.data.filter(value => value.StatusATG === 'ONLINE').length;
        },
        totalAtgOffline() {
            return this.unit.atgoffline.reduce((acc, item) => acc + item.Cnt, 0);
        },
		totalSpbuUpdate() {
            return this.unit.spbuupdate.reduce((acc, item) => acc + item.Cnt, 0);
        },
        totalSpbuNotUpdate() {
            return this.unit.spbunotupdate.reduce((acc, item) => acc + item.Cnt, 0);
        },
		totalStoreUpdate() {
            return this.unit.storeupdate.reduce((acc, item) => acc + item.Cnt, 0);
        },
        totalStoreNotUpdate() {
            return this.unit.storenotupdate.reduce((acc, item) => acc + item.Cnt, 0);
        }
    }
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>
